import { COLOR_PALETTE } from 'constants/ui';

export const titleTypographyStyles = {
  marginBottom: '12px',
  fontSize: '1.8rem',
  fontWeight: 600,
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
};

export const tableContainerStyles = {
  marginBottom: '12px',
  border: '1px solid',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderRadius: '8px',
};

export const commonTableHeadStyles = {
  padding: '8px 15px',
  fontWeight: 600,
  lineHeight: '1.6rem',
  color: ({ palette }) => palette.text.primary,
};

export const commonTableBodyStyles = {
  padding: '4px 15px',
  fontWeight: 400,
  lineHeight: '2.2rem',
  color: ({ palette }) => palette.text.secondary,
};

export const pendingChangeCellStyles = { marginLeft: 'auto', width: 'auto' };

export const footerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '12px',
  fontSize: '1.8rem',
  fontWeight: 500,
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: COLOR_PALETTE.GRAY[2],
  borderRadius: '8px',
};
